import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { OwnerUserService } from '../../../../../../services/owner-user.service';
import { Helpers } from '../../../../../../helpers';
import { BaseComponent } from '../../../base.component';
import { OwnerUser } from '../../../../../../models/owner-user';

@Component({
    selector: 'app-users',
    templateUrl: './create-user.component.html',
    encapsulation: ViewEncapsulation.None
})
export class CreateUserComponent extends BaseComponent implements OnInit {
    user: OwnerUser = new OwnerUser();

    constructor(private userService: OwnerUserService, private router: Router) {
        super();
    }

    ngOnInit() { }

    validate(event) {
        var customRules = this.validationService.customRules;
        return this.validationService.validate(event, {
            rules: {
                firstName: customRules.requiredText,
                lastName: customRules.requiredText,
                email: customRules.requiredEmail,
                password: customRules.requiredText
            }
        });
    }

    createUser() {
        Helpers.setLoading(true);
        var _self = this;
        this.userService.create(this.user).subscribe(() => {
            Helpers.setLoading(false);
            this.swalService.successCreate();
            setTimeout(function() {
                _self.router.navigate(['/owner/users/list']);
            }, 1000);
        });
    }
}



// WEBPACK FOOTER //
// /Users/creative/Documents/GitHub/makrooreservation/src/ui/src/app/theme/pages/default/owner/owner-user/create-user/create-user.component.ts